/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum GroupOrderingFilterEnum {
  /**
   * najstaršieho
   */
  CREATED_TIME = "CREATED_TIME",
  /**
   * najstaršieho
   */
  CREATED_TIME_DESC = "CREATED_TIME_DESC",
  /**
   * Zoradiť podľa dátumu posledného príspevku
   */
  LAST_POST_TIME = "LAST_POST_TIME",
  /**
   * Zoradiť podľa dátumu posledného príspevku
   */
  LAST_POST_TIME_DESC = "LAST_POST_TIME_DESC",
  /**
   * ORDER_BY_MEMBER_COUNT
   */
  MEMBERS_COUNT = "MEMBERS_COUNT",
  /**
   * ORDER_BY_MEMBER_COUNT
   */
  MEMBERS_COUNT_DESC = "MEMBERS_COUNT_DESC",
  /**
   * ORDER_BY_POSTS_COUNT
   */
  POSTS_COUNT = "POSTS_COUNT",
  /**
   * ORDER_BY_POSTS_COUNT
   */
  POSTS_COUNT_DESC = "POSTS_COUNT_DESC",
}